import { render, staticRenderFns } from "./PracticeOrderView.vue?vue&type=template&id=51bf239e&scoped=true"
import script from "./PracticeOrderView.vue?vue&type=script&lang=js"
export * from "./PracticeOrderView.vue?vue&type=script&lang=js"
import style0 from "./PracticeOrderView.vue?vue&type=style&index=0&id=51bf239e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bf239e",
  null
  
)

export default component.exports